import { Component, OnInit, HostListener, ViewChild, ElementRef, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';
import { FileInfo, SelectEvent, RemoveEvent, SuccessEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { AutoCompleteComponent, DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { MasterDataService } from '../../../core/services/master-data.service';
import { from, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import {
  ICountry, IDropDownData,
  IGetAllSupportDataForCheckOutOrderDetail,
  IMasterData,
  IState,
  IcheckoutOrderDetails,
  IOrderDetail,
  IJobNameSearch,
  IJobSearch,
  ICheckOutOrderDetailsLbl,
  IBaseResponse,
  ICreditCardFreightAmount,
  ICustomer
} from 'src/app/core/models';
import { CheckoutService } from '../../../core/services/checkout.service';
import { FormGroup, FormControl } from '@angular/forms';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { UserService } from '../../../core/services/user.service';
import { JobService } from '../../../core/services/job.service';
import { SortDescriptor, State, process } from '@progress/kendo-data-query';
import { IPromocodes, IApiResultResponse, ITaxCertificates } from '../../../core/models/index';
import { BehaviorSubject, Subscription } from 'rxjs';
import { cloneDeep } from 'lodash';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { HelperService } from '../../../core/services/helper.service';
import { Console } from 'console';

@Component({
  selector: 'app-orderdetails',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderdetailsComponent implements OnInit {
  orderLblText: ICheckOutOrderDetailsLbl;
  public selectedEmail: Array<string> = [];
  public minRequestDate: Date = new Date();
  public maxRequestDate: Date = new Date(this.minRequestDate.getFullYear() + 1,
    this.minRequestDate.getMonth(),
    this.minRequestDate.getDate());
  public showSuggestionBox: boolean;
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif", ".pdf", ".doc", ".docx", ".csv", ".xls", ".xlsx"],
  };
  //myFiles: Array<FileInfo> = [];
  public RequestDateTypeDropdwon: any[] = [
    { name: "Not Specified", value: "NONE" },
    { name: "Ship by Request Date", value: "CUST" },
    { name: "Do not ship before Request Date", value: "DNSE" }
  ];
  selectedRequestDateType: string = "";
  selectedRequestDateTypeval: string = "";
  isRequestTypeDisable: boolean = false;

  public shipCompleteDropdwon: any[] = [
    { name: "Not Specified", value: "Not Specified On PO" },
    { name: "Ship Complete", value: "Must Ship Complete" },
    { name: "Partials Accepted", value: "OK for Partial Shipments" }
  ];
  shipCompleteType: string = "Not Specified";
  shipCompleteTypeval: string = "Not Specified On PO";
  protected get getjobState$(): IState[] {
    return this.masterDataService.allStatesOfUsAndCanada;
  }
  public filteredTaxCertificatesItems: ITaxCertificates[];
  public taxertificatesItemsOrg: ITaxCertificates[];
  public searchTaxCertificatesItems: ITaxCertificates;
  public currentInputValueInItemSearch: string;
  public taxCertificatesSearchLoading: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  public data: IState[];

  @ViewChild('requestDateTypeDropdown', { static: false })
  public requestDateTypeDropdownvc!: DropDownListComponent;
  constructor(
    private masterDataService: MasterDataService,
    protected checkoutService: CheckoutService,
    private jobService: JobService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService, private helperService: HelperService) {
    this.masterDataService.getMarketSegments().then(r => {
      r.forEach((m: any) => {
        this.marketSegments.push({ name: m.name, marketSegment: m.name, value: m.value });
      });
      //console.log(this.marketSegments)
    });


  }

  public orderDetails: {
    jobName: "",
    jobNameData: [],
    jobState: "",
    jobStateData: []
    leed: true,
    jobCity: "",
    taxable: true

  }


  public set getjobState(value: IState[]) {
    this.masterDataService.allStatesOfUsAndCanada = value;
  }

  //public get getMarketSegment$(): Observable<IMasterData[]> {
  //  return this.masterDataService.GetMarketSegment();
  //}

  public get getFreightTerms$(): Observable<IMasterData[]> {
    return this.masterDataService.getFreightTerms$;
  }

  public get orderdetail(): IOrderDetail {
    return this.checkoutService.checkOutProcessModel.orderDetail;
  }

  public set orderdetail(value: IOrderDetail) {
    this.checkoutService.checkOutProcessModel.orderDetail = value;
  }

  public get orderDetailsForm() {
    return this.checkoutService.orderDetailsForm;
  }

  public set orderDetailsForm(value) {
    this.checkoutService.orderDetailsForm = value;
  }

  public validateForm() {
    this.checkoutService.validateODForm();
  }

  //on back space its setting the data before filtering and hence not able to get the data after backspace
  handleStatesFilterChange(value) {
    this.data = this.getjobState$.filter((s) => s.stateDescription.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  //#region confirm email multiple select
  //public onEmailSelect(value) {
  //  const selectedVal = value.slice(-1).pop()
  //  const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //  const res = regExp.test(String(selectedVal).toLowerCase());
  //  if (res) {
  //    this.selectedEmail = value;
  //  } else {
  //    const index = this.selectedEmail.findIndex(r => r === selectedVal);
  //    const tempData = this.selectedEmail.find(r => r === selectedVal);
  //    if (tempData) {
  //      this.selectedEmail.splice(index, 1);
  //    }
  //  }
  //}
  requestDateTypeChange(event: any) {
    this.selectedRequestDateType = event.name;
    this.selectedRequestDateTypeval = event.value;
    this.checkoutService.checkOutProcessModel.orderDetail.requestDateType = event.value;
    this.validateForm();
  }
  shipCompleteChange(event: any) {
    this.shipCompleteType = event.name;
    this.shipCompleteTypeval = event.value;
    this.checkoutService.checkOutProcessModel.orderDetail.sOShippingMethod = event.value;
  }

  isEmailFormatInvalid: boolean = false;
  public checkConfirmEmail(value) {
    this.isEmailFormatInvalid = false;
    this.selectedEmail = value;
    var isValidEmail = true;
    if (value) {
      if (value.length > 0) {
        for (var i = 0; i < value.length; i++) {
          const res = this.helperService.validateEmail((value[i]).toLowerCase());
          if (!res) {
            isValidEmail = false;
          }
        }
        if (!isValidEmail) {
          this.isEmailFormatInvalid = true;
          this.checkoutService.orderDetailsForm.isInvalidConfirmEmail = true;
        } else {
          this.checkoutService.orderDetailsForm.isInvalidConfirmEmail = false;
        }
      } else {
        this.checkoutService.orderDetailsForm.isInvalidConfirmEmail = false;
      }
    }


  }

  onDateKeyDown(event: KeyboardEvent) {
    if (event.key == "Tab") {
      if (this.orderdetail.requestDate) {
        this.isRequestTypeDisable = false;
        event.preventDefault();
        setTimeout(() => {
          this.requestDateTypeDropdownvc.focus();
        }, 50)
      }
    }
  }
  public checkRequestDateType() {
    if (!this.orderdetail.requestDate && this.RequestDateTypeDropdwon.length == 2) {
        this.checkoutService.checkOutProcessModel.orderDetail.requestDateType = "NONE";
        this.selectedRequestDateType = "Not Specified";
        this.selectedRequestDateTypeval = "NONE";
        this.isRequestTypeDisable = false;
        this.RequestDateTypeDropdwon.push({ name: "Not Specified", value: "NONE" });
      }
  }
  public checkRequestDate() {
    if (this.orderdetail.requestDate) {
      if (this.RequestDateTypeDropdwon.length > 2) {
        this.isRequestTypeDisable = false;
        this.RequestDateTypeDropdwon.splice(this.RequestDateTypeDropdwon.findIndex(item => item.value === "NONE"), 1);
        this.selectedRequestDateType = "";
        this.selectedRequestDateTypeval = "";
        this.checkoutService.checkOutProcessModel.orderDetail.requestDateType ="";
        console.log(this.RequestDateTypeDropdwon);
      }
    
      if (this.orderdetail.requestDate < this.minRequestDate || this.orderdetail.requestDate > this.maxRequestDate) {
        this.checkoutService.orderDetailsForm.isInvalidRequestDate = true;
      } else {
        this.checkoutService.orderDetailsForm.isInvalidRequestDate = false;
      }
    } else {
      this.checkoutService.orderDetailsForm.isInvalidRequestDate = false;
    }
  }
  public sizes: Array<string> = [];
  public selectedSizes: Array<string> = [];

  public get dynamicHeight() {
    return this.sizes.length ? 0 : 0;
  }


  //#endregion
  //adding quote number format on key press--Need to validate on paste later
  public quoteNumberFormat(txtVal) {
    if (txtVal.length == 6) {
      this.checkoutService.checkOutProcessModel.orderDetail.quoteNumber = this.checkoutService.checkOutProcessModel.orderDetail.quoteNumber + 'E-';
    }
  }

  //#region job name search
  public showJobNameListGrid: boolean;
  jobSearchGridData: GridDataResult;
  public jobCityDisabled: boolean = false;
  public jobStateDisabled: boolean = false;
  jobNameForm = new FormGroup({
    jobNumber: new FormControl(""),
    jobName: new FormControl(""),
    jobCity: new FormControl(""),
    jobState: new FormControl(""),
  })

  public toggleJobSearchDialog() {
    this.jobNameDialog.opened = !this.jobNameDialog.opened;
    this.showJobNameListGrid = false;
    if (this.jobNameDialog.opened == true) {
      this.jobNameForm.reset();
    }

  }
  public jobNameDialog = {
    opened: false,
    valid: false
  }
  taxCertificateForm = new FormGroup({
    taxCertificate: new FormControl(""),
  })
  public async toggletaxCertificatesDialog() {
    this.taxCertificatesDialog.valid = false;
    if (!this.taxCertificatesDialog.opened) {
      const taxResponse = await this.checkoutService.searchtaxCertificate();
      if (!taxResponse.isError) {
        this.taxertificatesItemsOrg = taxResponse.data;
        this.filteredTaxCertificatesItems = this.taxertificatesItemsOrg;
      }
    }
    this.taxCertificatesDialog.opened = !this.taxCertificatesDialog.opened;
    this.showJobNameListGrid = false;
    if (this.taxCertificatesDialog.opened == true) {
      this.taxCertificateForm.reset();
    }
  }
  public taxCertificatesDialog = {
    opened: false,
    valid: false,
  }
  splitText(eachItem: string) {
    if (this.currentInputValueInItemSearch.length === 1) {
      return eachItem.split('');
    }
    const regexString: string =
      this.currentInputValueInItemSearch +
      '|[^' +
      this.currentInputValueInItemSearch +
      ']|[0-9]|[a-z]';
    const regexConstructor: RegExp = new RegExp(regexString, 'gi');
    return eachItem.match(regexConstructor);
  }
  handleTaxCertificateFilter(searchQuery: any) {
    this.filteredTaxCertificatesItems = this.taxertificatesItemsOrg.filter((s) => s.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1);
  }
  onCloseCertificateChange(event) {
    this.filteredTaxCertificatesItems = this.taxertificatesItemsOrg;
  }
  selectedTaxCertificate: any;
  public taxCertificateChangeSelected(event) {
    this.selectedTaxCertificate = event.name;
    this.taxCertificatesDialog.valid = true;
    // this.changeCustomerDialog = false;
  }
  public addCertificatesCommentSubmit() {
    if (this.orderdetail.comments != undefined && this.orderdetail.comments != '') {
      this.orderdetail.comments += ", Tax Cert: " + this.selectedTaxCertificate;
    } else {
      this.orderdetail.comments = "Tax Cert: " + this.selectedTaxCertificate;
    }
    this.commentslength = this.orderdetail.comments.length;
    this.taxCertificatesDialog.opened = false;
  }
  onJobNameInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleanedValue = this.cleanFormatting(input.value);
    input.value = cleanedValue;
    this.orderdetail.jobName = cleanedValue;
  }
  onPoInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleanedValue = this.cleanFormatting(input.value);
    input.value = cleanedValue;
    this.orderdetail.po = cleanedValue;
  }
  onJobNameChange(value: Event) {
    const cleaned = value.target as HTMLInputElement;
    cleaned.value = this.cleanFormatting(cleaned.value);
    this.orderdetail.jobName = cleaned.value;
  }
  onPoNameChange(value: Event) {
    const cleaned = value.target as HTMLInputElement;
    cleaned.value = this.cleanFormatting(cleaned.value);
    this.orderdetail.po = cleaned.value;
  }
  public cleanFormatting(text: string): string {
    // Replace long dash with regular dash
    // Replace italic apostrophes with standard apostrophe
    return text
      .replace(/\u2013|\u2014/g, "-")
      .replace(/â€²/g, "'")
      .replace(/â€˜|â€™/g, "'")
      .replace(/\u0152/g, "OE")   // Å’
      .replace(/\u0153/g, "oe")   // Å“
      .replace(/\u0178/g, "Y");   // Å¸
  }
  
  //not used anywhere
  //public jobNameDialogData = {
  //  states: [] as IState[],
  //  //keeping static data --Need to get these from Apis
  //  data: [{ isSelected: true, jobNumber: '0123', jobName: 'job1', jobCity: 'test1', jobState: 'alaska' }, { isSelected: false, jobNumber: '1123', jobName: 'job2', jobCity: 'test2', jobState: 'alabama' }]
  //}
  public searchJobNameBody: IJobNameSearch;
  jobSearchResult: any;
  public SearchJobName() {
    //Need to check validation method here
    this.searchJobNameBody = {
      customerNumber: this.userService.readUserObject.customerNumber,
      userName: this.userService.readUserObject.userName,
      jobName: this.jobNameForm.controls.jobName.value,
      jobNumber: this.jobNameForm.controls.jobNumber.value,
      city: this.jobNameForm.controls.jobCity.value,
      state: this.jobNameForm.controls.jobState.value
    };
    //call Api method here
    this.jobSearchGridSettings.gridLoading = true;
    this.jobService.search(this.searchJobNameBody).subscribe((response) => {
      //console.log(response)
      this.jobSearchResult = response;
      this.loadJobs();
      this.jobSearchGridSettings.gridLoading = false;
      let selectJobDetails = this.jobSearchGridData.data[0];
      selectJobDetails.isSelected = true;
      this.jobSearchGridData.data[0].isSelected = selectJobDetails.isSelected;
    });
    this.showJobNameListGrid = true;
  }

  public jobSearchGridSettings = {
    gridLoading: true
  };

  public jobSearchGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'jobNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };



  public loadJobs(): void {
    this.jobSearchGridData = process(this.jobSearchResult, this.jobSearchGridState);
  }


  public jobSearchGridSortChange(sort: SortDescriptor[]): void {
    this.jobSearchGridState.sort = sort;
    this.loadJobs();
  }
  public jobSearchGridPageChange({ skip, take }: PageChangeEvent): void {
    this.jobSearchGridState.skip = skip;
    this.jobSearchGridState.take = take;
    this.loadJobs();
  }

  public jobSearchGridDataStateChange(state: DataStateChangeEvent): void {
    this.jobSearchGridState = state;
    this.loadJobs();
  }

  public selectJobName(dataItem: IJobSearch, rowIndex: number): void {

    console.log(dataItem);
    const selectedRow = this.jobSearchGridData.data.find(item => item.isSelected == true);
    if (selectedRow) {
      selectedRow.isSelected = false;
    }
    dataItem.isSelected = true;
  }
  public addJobDetails() {
    this.showJobNameListGrid = false;
    this.toggleJobSearchDialog();
    const selectedRow = this.jobSearchGridData.data.find(item => item.isSelected == true)
    if (selectedRow) {
      const index = this.jobSearchGridData.data.findIndex(item => item.isSelected == true)
      this.checkoutService.checkOutProcessModel.orderDetail.jobName = this.jobSearchGridData.data[index].jobName;
      this.checkoutService.checkOutProcessModel.orderDetail.jobCity = this.jobSearchGridData.data[index].city;
      this.checkoutService.checkOutProcessModel.orderDetail.jobState = { stateCode: this.jobSearchGridData.data[index].state, stateDescription: this.jobSearchGridData.data[index].state } as IState;
    }
    this.jobCityDisabled = true;
    this.jobStateDisabled = true;
    this.validateForm();
  }
  public crossIconClick() {
    if (this.checkoutService.checkOutProcessModel.orderDetail.jobName.length > 0) {

    } else {
      if (this.jobCityDisabled) {
        this.jobCityDisabled = false;
        this.jobStateDisabled = false;
        this.checkoutService.checkOutProcessModel.orderDetail.jobCity = "";
        this.checkoutService.checkOutProcessModel.orderDetail.jobState = { stateCode: "", stateDescription: "" } as IState;
      }

    }
  };

  //#endregion
  //#region Credit Information section
  public showCreditSection: boolean = false;
  showCreditCardDetails: boolean = false;

  public creditInfoLabel = {
    defaultCreditInfoLbl: 'Default credit card information',
    toModifyCreditLbl: 'If paying by Credit Card, provide in the Comment section the card type and last 4 digits of the card to be charged.',
    payByCreditLbl: 'Pay Order By Credit Card:',
    cardTypeLbl: 'Card Type:',
    cardTypeText: '',
    nameOnCardLbl: 'Name On Card:',
    nameOnCardText: '',
    creditCardNumberLbl: 'Credit Card Number:',
    cardNumberText: '',
    cardExpiryLbl: 'Expiration Month/Year:',
    cardExpiryText: '',
    expirationYear: '',
    expirationMonth: '',
  }
  public useCreditCard(selection) {
    if (selection == true) {
      this.showCreditCardDetails = true;
    } else {
      this.showCreditCardDetails = false;
    }
  }
  //#endregion

  @ViewChild('taxableInfo', { static: false }) public anchor: ElementRef;
  @ViewChild('popup', { static: false, read: ElementRef }) public popup: ElementRef;
  @ViewChild('jobNameAutoComplete', { static: false }) public autocomplete: AutoCompleteComponent;

  @Output() orderDetailsOut = new EventEmitter<IcheckoutOrderDetails>();  //getting this from checkout.compononent

  @Input() orderDetailsIn: IcheckoutOrderDetails;
  public commentslength: number = 0;
  public maxChars = 120;  //setting maxlength of comments textarea
  public showInfo = false;
  public detailsFormData: IcheckoutOrderDetails;

  public taxableCertificationLbl: string;

  public jobName: string;
  public jobCity: string;
  public jobState: IDropDownData;
  public po: string;
  public marketSegment: IDropDownData;
  public freightTerms: IDropDownData;
  public requestDate: Date;
  public confirmEmail: string;
  public leed: boolean;
  //public taxable: IDropDownData;
  public taxableData: IDropDownData[] = [{ text: "Yes", value: "YES" }, { text: "No", value: "NO" }];
  public defaultItem: IDropDownData = { text: 'Select value', value: 'DEFAULT' };
  public quotedInHouse: boolean;
  public freightNotes: string;
  public comments: string;
  public quoteNumber: string;
  public inputTax: string;
  public taxableCertification: string;
  public myFiles: Array<FileInfo> = [];

  public isDetailsFormValid: boolean;
  public jobNameData: any;
  public jobNameDataOld: any;
  public marketSegments: { name: string, marketSegment: string, value: string }[] = [];
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.inputTax = 'Enter YourTax Exempt Certificate No/PST Registration No. on file of Ship-To State/Province or upload file.';
    this.masterDataService.GetAllSupportDataForCheckOutOrderDetail().pipe(
      tap((response: IGetAllSupportDataForCheckOutOrderDetail) => {
        console.log(response);
        this.masterDataService.countries = response.countries as ICountry[];
        //this.masterDataService.states = response.countries[1].states as IState[];//hardocded usa for now length check required
        this.masterDataService.allStatesOfUsAndCanada = [...response.countries[0].states, ...response.countries[1].states];//]push(response.countries[0].states as IState);
        //this.masterDataService.allStatesOfUsAndCanada = [response.countries[1].states];
        // this.masterDataService.marketSegments = response.marketSegments as IMasterData[];
        this.masterDataService.freightTerms = response.freightTerms as IMasterData[];
        console.log(this.masterDataService.allStatesOfUsAndCanada);
      })
    ).subscribe((response: IGetAllSupportDataForCheckOutOrderDetail) => {
      this.data = this.masterDataService.allStatesOfUsAndCanada;
    });

    //this.masterDataService.GetMarketSegment().subscribe((res: IApiResultResponse) => {
    //  if (res.isError == false) {
    //    const data = res.data as IMasterData[];
    //    data.forEach(m => {
    //      this.marketSegments.push({ name: m.name, marketSegment: m.name });
    //    });
    //  } else {
    //    console.log(res.errorMessage);
    //  }
    //},
    //  error => {
    //    console.log(error);
    //  }
    //);

    this.sizes.push(""); //pushing empty values to confirm email dropdown on load
    this.selectedSizes = [];

    //if user is ccOnlyCheckout or ccCheckout roles then credit card section is not relevant here
    if (this.userService.isCheckoutCCCustomer() || this.userService.isCheckoutCConlyCustomer()) {
      this.showCreditSection = false;
    }
    else {
      this.showCreditSection = true;
      this.showCreditCardDetails = false;
      //calling credit card service to check if we should show the section
      //this.userService.getCreditInfo().subscribe((response) => {
      //  this.showCreditSection = true;
      //  //Need to check this if condition
      //  if (response.cardNumber) {
      //    this.creditInfoLabel.cardNumberText = response.cardNumber;
      //    this.creditInfoLabel.cardTypeText = response.cardType;
      //    this.creditInfoLabel.nameOnCardText = response.nameOnCard;
      //    this.creditInfoLabel.expirationYear = response.expirationYear;
      //    this.creditInfoLabel.expirationMonth = response.expirationMonth;
      //    this.creditInfoLabel.cardNumberText = response.cardNumber;
      //    if (response.isSavedAsDefault == true) {
      //      this.checkoutService.checkOutProcessModel.orderDetail.useCreditCard = true;
      //      this.showCreditCardDetails = true;
      //    } else {
      //      this.checkoutService.checkOutProcessModel.orderDetail.useCreditCard = false;
      //      this.showCreditCardDetails = false;
      //    }
      //  } else {
      //    this.showCreditSection = false;
      //  }

      //});
    }
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.checkConfirmEmail(this.orderdetail.confirmEmail);
    if (!this.checkoutService.checkOutProcessModel.orderDetail.requestDate) {
      this.checkoutService.checkOutProcessModel.orderDetail.sOShippingMethod = "Not Specified On PO";
      this.checkoutService.checkOutProcessModel.orderDetail.requestDateType = "NONE";
      this.selectedRequestDateType = "Not Specified";
      this.selectedRequestDateTypeval = "NONE";
      this.isRequestTypeDisable = true;
    }
    else if (this.RequestDateTypeDropdwon.length > 2) {
      this.RequestDateTypeDropdwon.splice(this.RequestDateTypeDropdwon.findIndex(item => item.value === "NONE"), 1);
      console.log(this.RequestDateTypeDropdwon);
      this.selectedRequestDateTypeval = this.checkoutService.checkOutProcessModel.orderDetail.requestDateType;
    }

   
    this.validateForm();//to reset the validation
    //Validate CC Customer
    if (this.userService.isCheckoutCCCustomer())
      this.checkOutCCCustomer = true;
    else if (this.userService.isCheckoutCConlyCustomer())
      this.checkOutCConlyCustomer = true;
    if (this.userService.getFreightEstimateFlag()) {
      this.freightEstimateFlag = true;
      this.loadFreightOnOrderDetails();
    }
    if (this.userService.getFreightEstimateNoteFlag())
      this.freightEstimateNoteFlag = true;
    this.shipToChangeSubscription = this.checkoutService.shipToChangeSubject.subscribe(val => {
      //handle freight update here if aapplicable
      console.log('Subscription received the value-->', val);
      if (this.checkoutService.prepaidFreightSelected)
        this.calculateFreightAmount();
    });
    if (this.orderdetail.freightTerms && this.orderdetail.freightTerms.value)
      this.freightTermsCalculation = this.orderdetail.freightTerms.value;
  }
  orderdetailsLbl = {
    jobSearchHeadingLbl: "Job Search",
    jobNumberLbl: 'Job Number',
    jobNameLbl: 'Job Name',
    jobCityLbl: 'Job City',
    jobStateLbl: 'Job State',
    poLbl: 'PO',
    marketSegmentLbl: 'Market Segment',
    frieghtTermsLbl: 'Freight Terms',
    requestDateLbl: 'Request Date',
    confirmEmailLbl: 'Confirm E-Mail Recipients',
    invalidConfirmEmail: "Email address is invalid",
    leedLbl: 'LEED',
    taxableLbl: 'Taxable',
    quotedInHouseLbl: 'Quoted In-House?',
    frightNotesLbl: 'Freight Notes',
    commentsLbl1: 'Comments',
    commentsLbl2: 'Comments for packing and shipping. Comments not to be used to alter order material(s).',
    quoteNumberLbl: 'Quote Number (XXXXXXE-XXX)',
    taxableCertificationLbl: 'Certificate/Registration No.',
    inputTax: 'Enter YourTax Exempt Certificate No/PST Registration No. on file of Ship-To State/Province or upload file.',
    characterRemainingLbl: 'Characters Remaining',
    promoCodeLbl: 'Promo Code?',
    promoApplyLbl: 'Apply',
    promoNotValidLbl: 'is not a valid code',
    promoValidLbl: 'has been verified and will be applied by kawneer during order processing',
    jobSearchBtnLbl: 'Search',
    addJobLbl: 'Add Job',
    taxablebuttonlbl: 'Certificates on file with Kawneer',
    taxabletitlelbl: 'Tax will be calculated at timing of invoicing based on valid State/Province/Project certificates on file with Kawneer',
    taxCertifiacteddlheadertxt: 'Active Certificates on File with Kawneer',
    taxCertifiactetitletxt: 'Tax Certificates',
    taxCertifiactebtntxt: 'Add Selected Certificate to Order Comments',
    taxCertifiactenotelbl: 'Please contact your customer service team to add or update certificates. Allow 24-48 hours for processing. Orders may be submitted while certificates are being processed. If you have a certificate that is processing with our team, be sure to include the certificate number in the order comments. Tax status will be verified against active certificates prior to invoicing.',
    frieghtTermsPrePaidLbl: 'Prepaid',
    frieghtTermsEstLbl: 'Estimate & include with order*',
    frieghtTermsEstMsgLbl: '*Shipping cost is estimated and subject to change at time of order entry',
    frieghtTermsPickupLbl: 'Pickup**',
    frieghtTermsCollectLbl: 'Collect',
    frieghtTermsPickupMsgLbl: '** Shipping costs may still be applicable for pickup orders depending upon the products originating location',
    frieghtTermsPrePaidText: 'Calculated & added to invoice at time of shipment',
    includeFreightLbl: 'Include Freight',
    includeFreightTitlelbl: 'Select “Yes” to generate freight costs for the products in your cart and include the freight cost in your order acknowledgement.  Select “No” if you receive an error message or if you would prefer to receive your freight costs only at invoicing.',
    requestDateTypeLbl: 'Request Date Type',
    shipCompleteLbl: 'Ship Complete/Partial'
  }
  //#region Language translate
  loadLanguageTranslationData() {
    //need to add remaining fields
    const controlNameList = [
      { controlName: "commentsLbl1" },
      { controlName: "commentsLbl2" },
      { controlName: "confirmEmailLbl" },
      { controlName: "invalidConfirmEmail" },
      { controlName: "frieghtTermsLbl" },
      { controlName: "inputTax" },
      { controlName: "jobNameLbl" },
      { controlName: "jobCityLbl" },
      { controlName: "jobStateLbl" },
      { controlName: "leedLbl" },
      { controlName: "stateLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "poLbl" },
      { controlName: "quotedInHouseLbl" },
      { controlName: "quoteNumberLbl" },
      { controlName: "requestDateLbl" },
      { controlName: "taxableCertificationLbl" },
      { controlName: "characterRemainingLbl" },
      //{ controlName: "promoCodeLbl" },
      { controlName: "promoApplyLbl" },
      { controlName: "promoNotValidLbl" },
      { controlName: "promoValidLbl" },
      { controlName: "defaultCreditInfoLbl" },
      { controlName: "toModifyCreditLbl" },
      { controlName: "payByCreditLbl" },
      { controlName: "cardTypeLbl" },
      { controlName: "nameOnCardLbl" },
      { controlName: "creditCardNumberLbl" },
      { controlName: "cardExpiryLbl" },
      { controlName: "taxablebuttonlbl" },
      { controlName: "taxabletitlelbl" },
      { controlName: "taxCertifiacteddlheadertxt" },
      { controlName: "taxCertifiactetitletxt" },
      { controlName: "taxCertifiactebtntxt" },
      { controlName: "taxCertifiactenotelbl" },
      { controlName: "frieghtTermsEstLbl" },
      { controlName: "frieghtTermsEstMsgLbl" },
      { controlName: "frieghtTermsPickupLbl" },
      { controlName: "frieghtTermsCollectLbl" },
      { controlName: "frieghtTermsPickupMsgLbl" },
      { controlName: "frieghtTermsPrePaidLbl" },
      { controlName: "frieghtTermsPrePaidText" },
      { controlName: "includeFreightLbl" },
      { controlName: "includeFreightTitlelbl" },
      { controlName: "requestDateTypeLbl" },
      { controlName: "shipCompleteLbl" },
    ];
    const componentName = "checkout-order-details";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.orderLblText = response[response.length - 1];
    }
  }

  //#endregion

  // to show the characters count entered in comment box
  commenttxtArea(event) {
    this.commentslength = event.target.value.length;
  }

  ngOnDestroy() {
    this.shipToChangeSubscription.unsubscribe();
  }

  // upload functions
  //selectEventHandler(e: SelectEvent) {
  //  e.files.forEach((file) => this.myFiles.push(file));
  //}
  //removeEventHandler(e: RemoveEvent) {
  //  const event = e;
  //  let removeItem;
  //  this.myFiles.splice(removeItem, 1);
  //}

  // shows the labels information on taxable info icon
  taxableInfoToggle() {
    this.showInfo = !this.showInfo;
  }

  // this handles the closing of taxable popup on outside click
  //@HostListener('document:click', ['$event'])
  //public documentClick(event: any): void {
  //  if (!this.contains(event.target)) {
  //    this.showInfo = false;
  //  }
  //}

  //public contains(target: any): boolean {
  //  return this.anchor.nativeElement.contains(target) ||
  //    (this.popup ? this.popup.nativeElement.contains(target) : false);
  //}

  // handle the job state change dropdown
  jobStateChange(event) {
    this.validateForm();
  }

  // handle the market segment change dropdown
  marketSegmentChange(event) {
    this.validateForm();
  }

  // handle the freight term dropdown change
  freightTermsChange(event) {
    this.validateForm();
  }
  taxableChange(event) {
    this.orderdetail.taxable = event.value;
    if (this.orderdetail.taxable != 'NO') {
      this.myFiles = [];
      this.orderdetail.taxFileName = '';
      this.orderdetail.taxFileName = '';
    }
  }

  //#region promo code----commented for now 
  //promocodesData: IPromocodes;
  //textMessage: string = "";
  //textdescription: string = "";
  //isValidPromoCode: boolean;
  //isEmptyPromoCode: boolean = false;
  //isPromoApply: boolean;
  //applyPromoCode() {
  //  this.isPromoApply = true;
  //  this.isValidPromoCode = false;
  //  this.isEmptyPromoCode = false;
  //  this.textMessage = "";
  //  this.textdescription = "";
  //  this.isPromoApply = true;
  //  const promoCode = this.checkoutService.checkOutProcessModel.orderDetail.promoCode;
  //  if (promoCode) {

  //    this.checkoutService.checkPromoCode(promoCode).subscribe((response) => {
  //      this.isPromoApply = false;
  //      if (response.length > 0) {
  //        //this.promocodesData = response;
  //        this.textMessage = promoCode + " has been verified and will be applied by kawneer during order processing";
  //        let description = response[0].promoCodeDescription;
  //        this.textdescription = description;
  //        this.isValidPromoCode = true;
  //      } else {
  //        this.textMessage = promoCode + " is not a valid code";
  //        this.isValidPromoCode = false;

  //      }
  //    });
  //  }
  //  else {
  //    this.isEmptyPromoCode = true;
  //    return;
  //  }
  //}


  //public validatePromoCode(): boolean {
  //  this.isValidPromoCode = false;
  //  this.textMessage = "";
  //  this.textdescription = "";
  //  if (this.isPromoApply == true) {
  //    const promoCode = this.checkoutService.checkOutProcessModel.orderDetail.promoCode;
  //    if (promoCode) {
  //      this.isEmptyPromoCode = false;
  //    }
  //    else {
  //      this.isEmptyPromoCode = true;
  //    }
  //    return this.isEmptyPromoCode;
  //  }

  //}

  //#endregion

  //----------file upload-------------------
  fileToUpload: File = null;
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    //this.orderdetail.file = files.item(0);

  }
  fileSelected(evt) {
    // console.log("FileSelected: " + evt.files[0].name);
    this.orderdetail.taxFileName = evt.files[0].name;
  }
  uploadSuccess(evt: SuccessEvent) {
    //console.log("Success: " + evt.response.body.paths[0]);
    this.orderdetail.taxFile = evt.response.body.paths[0];
  }
  uploadComplete() {
    //console.log("Complete");
  }
  uploadRemove(evt: RemoveEvent) {
    //console.log("Success: " + evt.response.body.paths[0]);
    this.orderdetail.taxFileName = '';
    this.orderdetail.taxFileName = '';
  }


  //#region Freight Calc Related methods & variables
  public shipToChangeSubscription;
  public checkOutCConlyCustomer: boolean = false;
  public checkOutCCCustomer: boolean = false;
  public freightEstimateFlag: boolean = false;
  public freightEstimateNoteFlag: boolean = false;
  public freightTermsCalculation: string = '';
  public isFreightTermsError: boolean = false;
  public isFreightTermMessage: boolean = false;
  public isFreightTermsErrorMsg: string = '';
  public freightCalcInProgress: boolean;
  public isRetry : boolean;
  public freightLeedInProcess: boolean;
  selectedFreightTermsIdForCCOrder = -1;
  public freightTermSelection: number = 0;
  async SwitchFrieghtInclude(event) {
    this.isFreightTermsError = false;
    if (this.checkoutService.prepaidFreightSelected) {
      this.checkoutService.prepaidFreightSelected = true;
      await this.calculateFreightAmount();
    } else {
      this.checkoutService.prepaidFreightSelected = false;
    }
  }
  async loadFreightOnOrderDetails() {
    var selectedTermsId = parseInt(this.orderdetail.freightTerms.value);
    if (selectedTermsId == 1 && this.orderdetail.freightTerms.name.toLowerCase().indexOf('standard shipment') > -1) {
      this.freightTermSelection = 1;
    } else if (selectedTermsId == 4) {
      this.freightTermSelection = 2;
    }
  }
  async selectfrieghtTerms(event) {
    this.checkoutService.prepaidFreightSelected = false;
    this.freightTermSelection = 0;
    this.isFreightTermsError = false;
    var selectedTermsId = parseInt(this.orderdetail.freightTerms.value);
    if (selectedTermsId == 1 && this.orderdetail.freightTerms.name.toLowerCase().indexOf('standard shipment') > -1) {
      this.freightTermSelection = 1;
    } else if (selectedTermsId == 4) {
      this.freightTermSelection = 2;
    }
    this.isRetry = false;
    this.freightCalcInProgress = false;
    this.isFreightTermMessage = false;
    this.freightTermsCalculation = selectedTermsId.toString();
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.selectedFreightTermsIdForCCOrder = selectedTermsId;
  }
  async selectLeed() {
    //this.freightLeedInProcess = false;
    if (this.checkoutService.prepaidFreightSelected) {
      /*this.freightLeedInProcess = true;*/
      await this.calculateFreightAmount();
    }
    //  this.freightLeedInProcess = false;
  }
  shippingDevNote = '';
  async calculateFreightAmount() {
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.isRetry = false;
    this.freightCalcInProgress = true;
    this.checkoutService.freightCalcInProgress = true;
    this.shippingDevNote = '';
    this.isFreightTermsError = false;
    this.checkoutService.calculateFreightAmountByOrder(false).subscribe((response: ICreditCardFreightAmount) => {
      this.isFreightTermsError = false;
      this.freightCalcInProgress = false;
      this.isFreightTermsErrorMsg = '';
      this.checkoutService.freightCalcInProgress = false;
      if (!response.isError) {
        this.checkoutService.checkOutProcessModel.freightAmount = response.freightAmount;
        this.checkoutService.checkOutProcessModel.freightUniqueId = response.message;
        this.checkoutService.freightAmountChangeSubject.next(response.freightAmount);
        this.checkoutService.prepaidFreightCalcSuccess = true;
        console.log("Shipping Note: " + response.shipmentNote);
        this.shippingDevNote = response.shipmentNote;
      } else {
        //this.isRetry = true;
        this.checkoutService.prepaidFreightSelected = false;
        this.isFreightTermsError = true;
        this.isFreightTermsErrorMsg = "Sorry an error occured while calculating freight amount. Please try again. If you get error again";
        if (response.isRetryDisable) {
          this.isFreightTermsErrorMsg = response.message;
          this.isRetry = false;
        }
        this.checkoutService.prepaidFreightCalcSuccess = false;
        this.checkoutService.checkOutProcessModel.freightUniqueId = "";
      }
    });//must add exception hadler here
  }
  //#endregion
}
